import React from "react";

/** Prompt when approve fails due to insufficient funds — matches deny popup layout. */
export const InsufficientFundsQueueStep = ({ onYes, onNo, loading }) => (
  <>
    <div className="authorise-bank-transfer-header">
      <h4 className="authorise-bank-transfer-title yellow">{Drupal.t("Queue Authorization?")}</h4>
    </div>
    <div className="authorise-bank-transfer-body-content">
      <div className="authorise-bank-transfer-description black text-center">
        <p>
          {Drupal.t(
            "There are currently not enough funds in your account to complete this transfer. Would you like to put the transfer in a queue to be automatically paid as soon as sufficient funds are available?",
          )}
        </p>
      </div>
    </div>
    <div className="authorise-bank-transfer-actions step1-button gap-3 mt-4">
      <button
        type="button"
        className="secondary_btn"
        onClick={onNo}
        disabled={loading}
      >
        {Drupal.t("No")}
      </button>
      <button
        type="button"
        className="primary_btn"
        onClick={onYes}
        disabled={loading}
      >
        {loading ? Drupal.t("Loading…") : Drupal.t("Yes")}
      </button>
    </div>
  </>
);
